export default __webpack_public_path__ + "static/forum-logo-083f0d9e6430cf1f6ee48cbb7c8b5e4f.png";